import {
    closest,
    toggleClass as toggleCls,
    addEventListener as on,
    hasClass,
} from 'dom-helpers';

export default doc => {
    on(doc, 'click', e => {
        let $video = closest(e.target, '.video');
        if (!e.target || !$video || hasClass($video, 'video-self')) return;

        toggleCls($video, 'is-playing');
        let $vid = $video.getElementsByTagName('iframe');
        if ($vid && $vid.length > 0) {
            $vid[0].src = $vid[0].dataset.src;
        }
    });
};
